import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { getNewComics } from '@/mocks/comics';

export default function NewUpdatesSection() {
  const newComics = getNewComics();

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              最新<span className="text-secondary-600">更新</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">最新上架的韩漫作品，第一时间追更</p>
          </div>
          <Link
            to="/category/fantasy"
            className="hidden sm:flex items-center gap-1 text-sm text-secondary-600 hover:text-secondary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {newComics.map((comic) => (
            <div key={comic.id} className="relative">
              <div className="absolute top-2 right-2 z-10">
                <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-secondary-500 text-background-50 whitespace-nowrap">
                  <i className="ri-time-line"></i> {comic.updateDate}
                </span>
              </div>
              <ComicCard comic={comic} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}